module.exports = __webpack_public_path__ + "img/sum.4ce48fe6.svg";